import { Modal } from "antd"
import { useEffect } from "react";

export const ModalRc = (props) => {
    const {
        type,
        classModal = 'info',
        title,
        content = '',
        okText = "ตกลง",
        cancelText = 'ยกเลิก',
        onOk,
        onCancel,
        ...resProp
    } = props


    // useEffect(() => {
    //     if (dataChange !== null) {
    //         setIsModalVisible(true); // เปิด Modal เมื่อข้อมูลเปลี่ยน
    //     }
    // }, [dataChange]);

    let propsModal = {
        title,
        content,
        className: `modal-message modal-message-${classModal}`,
        ...resProp
    }
    console.log("22 propsModal", cancelText, okText);

    if (onOk) {
        propsModal = {
            ...propsModal,
            okText,
            onOk,
            okButtonProps: { className: type === 'success' ? '' : 'btn-custom' }
        }
    }

    if (onCancel) {
        propsModal = {
            ...propsModal,
            cancelText,
            onCancel,
            cancelButtonProps: { className: 'btn-clear' }
        }
    }
    console.log("43 warning", type, { ...propsModal })
    switch (type) {
        case 'confirm':
            return Modal.confirm({ ...propsModal })
        case 'warning':
            return Modal.warning({ ...propsModal })
        case 'success':
            return Modal.success({ ...propsModal })
        default:
            return Modal.info({ ...propsModal })
    }

}